const visibilityObserver =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            entry.target.toggleAttribute('data-promo-visible', entry.isIntersecting);
          }
        },
        { rootMargin: '120px' }
      )
    : null;

class Promo3x2Badge extends HTMLElement {
  connectedCallback() {
    if (visibilityObserver) {
      visibilityObserver.observe(this);
    } else {
      this.setAttribute('data-promo-visible', '');
    }
  }

  disconnectedCallback() {
    visibilityObserver?.unobserve(this);
  }
}

if (!customElements.get('promo-3x2-badge')) {
  customElements.define('promo-3x2-badge', Promo3x2Badge);
}
